import { supabase } from "@/integrations/supabase/client";
import { getAnonToken } from "@/lib/studio";

export type SharePaletteItem = {
  surface: string;
  hex: string;
  name: string;
  number: string;
  brand: string;
};

export type StudioShare = {
  id: string;
  token: string;
  project_id: string | null;
  version_id: string | null;
  name: string | null;
  source_image_url: string;
  rendered_image_url: string | null;
  palette: SharePaletteItem[];
  view_count: number;
  created_at: string;
};

export async function createShare(input: {
  projectId: string | null;
  versionId?: string | null;
  name: string | null;
  sourceImageUrl: string;
  renderedImageUrl: string | null;
  palette: SharePaletteItem[];
}): Promise<StudioShare> {
  const { data: userRes } = await supabase.auth.getUser();
  const userId = userRes.user?.id ?? null;
  const { data, error } = await supabase
    .from("studio_shares")
    .insert({
      project_id: input.projectId,
      version_id: input.versionId ?? null,
      name: input.name,
      source_image_url: input.sourceImageUrl,
      rendered_image_url: input.renderedImageUrl,
      palette: input.palette as unknown as any,
      user_id: userId,
      anon_token: userId ? null : getAnonToken(),
    })
    .select("id,token,project_id,version_id,name,source_image_url,rendered_image_url,palette,view_count,created_at")
    .single();
  if (error) throw error;
  return data as unknown as StudioShare;
}

export async function getShareByToken(token: string): Promise<StudioShare | null> {
  const { data, error } = await supabase.rpc("get_studio_share_by_token", { _token: token });
  if (error) throw error;
  return (data as unknown as StudioShare) ?? null;
}

export function shareUrl(token: string): string {
  if (typeof window === "undefined") return `/share/${token}`;
  return `${window.location.origin}/share/${token}`;
}